// src/components/Travel.js
import React from 'react';
import '../styling/Travel.css'; // Optional

// Import local images
import visaImg from '../images/usflag.jpg';
import residencyImg from '../images/permanent_resident.jpg';
import asylumImg from '../images/asylum.jpg';
import dvLotteryImg from '../images/usflag.jpg';

const Travel = () => {
  return (
    <>

      <div className=" travel dep-card">
        <h3>Travel Agency</h3>
        <div className="card">

          {/* Visa Assistance */}
          <div className="service-card">
            <img src={visaImg} alt="Visa assistance" />
            <div className="service-info">
              <h4><i className="fas fa-passport"></i>&nbsp; Visa Assistance</h4>
              <p>We provide comprehensive assistance with a wide range of visa types, including tourist, student, work, and family visas. Our team supports you throughout the entire process — from gathering and preparing the necessary documentation, to accurately completing your application, submitting it to the relevant authorities, and monitoring its progress. We also offer guidance on interview preparation and help resolve any issues that may arise during the approval process, ensuring a smoother and more confident experience from start to finish.</p>
            </div>
          </div>

          {/* Permanent Residency */}
          <div className="service-card">
            <img src={residencyImg} alt="Permanent residency" />
            <div className="service-info">
              <h4><i className="fas fa-home"></i>&nbsp; Permanent Residency Assistance</h4>
              <p>Embarking on the journey toward permanent residency is a significant step, one that can open doors to new opportunities, a stable future, and a fulfilling life in your chosen country. We specialize in helping individuals navigate the pathway to permanent residency. With a deep understanding of immigration laws and policies, we tailor our services to meet the specific requirements of the country you're applying to. From determining eligibility to preparing the necessary documents, we are committed to ensuring that you meet all the legal criteria for a successful application. Our team works closely with you to ensure that your forms are filled out correctly, supporting evidence is complete, and all application deadlines are met. We also offer guidance on factors such as health checks, financial stability, language proficiency, and other mandatory requirements that may be part of the process.</p>
            </div>
          </div>

          {/* Asylum Assistance */}
          <div className="service-card">
            <img src={asylumImg} alt="Asylum assistance" />
            <div className="service-info">
              <h4><i className="fas fa-hand-holding-heart"></i>&nbsp; Abroad Asylum Assistance</h4>
              <p>Specialist support on asylum claims, legal pathways, and required documentation. Our Asylum Assistance program is specifically designed to help individuals who are applying for asylum in a country other than their current place of residence. Whether you're fleeing persecution, conflict, or other threats to your safety, we are here to support you in navigating the legal, procedural, and emotional challenges of seeking asylum in a foreign country. Country-Specific Guidance: We provide you with clear, detailed information on the asylum process for the country you wish to seek refuge in. This includes helping you understand the specific asylum requirements, eligibility criteria, documentation needed, and timelines for submission in your chosen destination country. We understand the hardships and uncertainties that come with seeking asylum, and we are dedicated to providing the highest level of support and assistance. Our goal is to make the asylum process as clear, efficient, and stress-free as possible so that you can focus on building a safer, brighter future for yourself.</p>
            </div>
          </div>

          {/* DV Lottery */}
          <div className="service-card">
            <img src={dvLotteryImg} alt="DV Lottery" />
            <div className="service-info">
              <h4><i className="fas fa-globe-americas"></i>&nbsp; DV Lottery Assistance</h4>
              <p>Our DV Lottery Assistance Service is designed to simplify the entry process and improve your chances of success. Instead of navigating the U.S. government's system alone, you can fill out our easy-to-use form directly inside the VOETA mobile app. Once submitted, our experts will review your data for accuracy and submit your application on your behalf through the official government website — ensuring every detail is correctly handled and deadlines are met. With your consent, we securely store your profile in our system, allowing us to automatically resubmit your application in future years — saving you time and effort.

If you win the lottery: VOETA will provide a full travel support package for you and your family. This includes a dedicated loan to cover visa fees, flight tickets, and relocation costs, along with guaranteed accommodation in the United States upon arrival. We don’t just help you apply — we help you start your new life with confidence and security.</p>
            </div>
          </div>

        </div>
      </div>
      <style>
        {`
        .travel .dep-card {
    max-width: 1100px;
    padding: 5px;
    margin: 20px auto;
    margin-top: 70px;
  }
  .travel .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }
  .travel .card {
    display: flex;
    flex-wrap: wrap;
    margin: auto;
    max-width: 1100px;
  }
  .travel .dep-card h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 30px;
  }

  .travel .service-card {
    background: #ffffff;
    border-radius: 30px;
    padding: 5px;
    margin: 20px;
    border: 1px solid #040404;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s;
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 20px;
    align-items: stretch;
  }

  .travel .service-card:hover {
    transform: translateY(-5px);
  }

  .travel .service-card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 20px;
  }

  .travel .service-card .service-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .travel .service-card h4 {
    color: #007bff;
    font-size: 18px;
    margin-bottom: 10px;
  }

  .travel .service-card p {
    color: #555;
    margin-bottom: 10px;
  }

  .travel .service-card .cost {
    font-weight: bold;
    color: #28a745;
  }

  .travel .service-card .cost-details {
    font-size: 14px;
    color: #777;
  }

  @media (max-width: 1200px) {
    .travel .service-card {
      grid-template-columns: 1fr;
      gap: 10px;
    }
    .travel .container {
      width: 100%;
      max-width: none;
      padding: 20px;
    }
    .travel .service-card img {
      width: 100%;
      height: 200px;
    }
    .travel .service-card h4 {
      font-size: 15px;
      text-align: center;
    }
    .travel .service-card .service-info {
      width: 100%;
      margin-top: 10px;
    }
  } 
        `}
      </style>

    </>
  );
};

export default Travel;